var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.219971 3.8584V6.20102L5.6997 9.36412L7.72861 10.5354L9.10968 9.73723L9.49579 9.51448V7.17371L7.72861 8.19466L0.219971 3.8584Z",
    fill: "#1F1752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79209 5.19697L9.49537 3.05854V0.717773L3.76318 4.02752L5.79209 5.19697Z",
    fill: "#1F1752"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3941 8.19466L11.627 7.17371V9.51448L12.0131 9.73723L13.3941 10.5354L15.423 9.36412L20.9028 6.20102V3.8584L13.3941 8.19466Z",
    fill: "#1F1752"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3591 4.02752L11.627 0.717773V3.05854L15.3302 5.19697L17.3591 4.02752Z",
    fill: "#1F1752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogic);
export default __webpack_public_path__ + "static/media/ic_logic.56d33c195c976817c10bf2f7c459e621.svg";
export { ForwardRef as ReactComponent };